module.exports = "<ul class=\"modal-banner-list\">\n    <li>Unlimited clients</li>\n    <li>Unlimited jobs</li>\n    <li>Unlimited invoices</li>\n    <li>Workflow automation</li>\n    <li>Electronic contracts</li>\n    <li>Online payments</li>\n    <li>Fast support</li>\n</ul>"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/subscription/subscription-elements/subscription-banner-list/subscription-banner-list.html
// module id = ./web/modern/components/subscription/subscription-elements/subscription-banner-list/subscription-banner-list.html
// module chunks = 0